import React from 'react';
import { SiPostman, SiDjango } from "react-icons/si";

export default function Skills() {
  return (
    <div >
      <h2 class="text-2xl font-Kalam font-bold md:text-4xl md:leading-tight text-center uppercase text-black mt-20 mb-10">
      <span class="underline underline-offset-3 decoration-3 decoration-black dark:decoration-black">Skills</span></h2>

      <div className=" max-w-6xl mx-auto p-5 py-5 " id="skills">
        <div className="text-4xl md:text-4xl text-center md:text-left font-medium text-gray-900 pb-4 mb-2">

        </div>


        <div className="grid grid-cols-2 md:grid-cols-4 gap-4">
          {skills.map((skill) => {
            return (
              <div className="flex space-x-2 items-center p-5 bg-gray-800 rounded-md">
                {skill.icon && <div className="text-2xl">{skill.icon}</div>}
                {skill.img && <img src={skill.img} className="h-6 w-6" alt=""></img>}
                <div className=" text-gray-300">{skill.skill}</div>
              </div>
            );
          })}
        </div>
      </div>
    </div>
  );
}

const skills = [
  {
    icon: <i className="devicon-react-original colored"></i>,
    skill: 'ReactJS',
  },
  {
    img: 'https://cdn.jsdelivr.net/gh/devicons/devicon/icons/python/python-original.svg',
    skill: 'Python',
  },
  {
    icon: <SiDjango />,
    skill: 'Django',
  },
  {
    img: 'https://cdn.jsdelivr.net/gh/devicons/devicon/icons/mysql/mysql-original.svg',
    skill: 'MySQL',
  },
  {
    icon: <i className="devicon-redux-original colored"></i>,
    skill: 'Redux',
  },
  {
    icon: <i className="devicon-tailwindcss-plain colored"></i>,
    skill: 'Tailwind CSS',
  },
  {
    icon: <i className="devicon-bootstrap-plain colored"></i>,
    skill: 'Bootstrap',
  },
  {
    img: 'https://cdn.jsdelivr.net/gh/devicons/devicon/icons/javascript/javascript-original.svg',
    skill: 'JavaScript',
  },
  {
    img: 'https://cdn.jsdelivr.net/gh/devicons/devicon/icons/c/c-original.svg',
    skill: 'C',
  },
  {
    img: 'https://cdn.jsdelivr.net/gh/devicons/devicon/icons/java/java-original.svg',
    skill: 'Java',
  },
  {
    icon: <i className="devicon-nodejs-plain colored"></i>,
    skill: 'Node JS',
  },
  {
    icon: <i className="devicon-express-original colored"></i>,
    skill: 'Express JS',
  },
  {
    icon: <i className="devicon-html5-plain-wordmark colored"></i>,
    skill: 'HTML',
  },
  {
    icon: <i className="devicon-css3-plain colored"></i>,
    skill: 'CSS',
  },

  {
    icon: <SiPostman />,
    skill: "Postman"
  },
  {
    img: 'https://cdn.jsdelivr.net/gh/devicons/devicon/icons/mongodb/mongodb-original.svg',
    skill: 'MongoDB',
  },








];
